import { useEffect, useState } from "react";
import * as React from "react";
import { Progress, Typography } from 'antd';

const { Text } = Typography;

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    width: '100vw',
    padding: '0 24px', // Adds horizontal margin
    boxSizing: 'border-box' as const,
    textAlign: 'center' as const,
  },
  label: {
    marginTop: 8,
    fontSize: 16,
    color: '#555',
  },
};

const FakeProgressBar = () => {
  const [progress, setProgress] = useState(0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    Office.onReady().then(() => {
      // Notify parent that the dialog is ready to receive messages
      Office.context.ui.messageParent("ready");

      Office.context.ui.addHandlerAsync(
        Office.EventType.DialogParentMessageReceived,
        (arg) => {
          if (arg.message === "done") {
            setProgress(100);
            setDone(true);
            Office.context.ui.messageParent("done");
          }
        }
      );
    });
  }, []);

  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (!done) {
      interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 98) return prev; // Don't go all the way to 100%
          return prev + Math.random() * 0.2; // Much smaller increment for slower progress
        });
      }, 200); // Increased interval for slower updates
    }

    return () => clearInterval(interval);
  }, [done]);


  return (
    <div style={styles.container}>
      <Progress
        type="line"
        percent={Math.round(progress)}
        status={done ? 'success' : 'active'}
        strokeColor={done ? undefined : 'rgb(255, 92, 53)'}
      />
      <Text style={styles.label}>
        {done ? 'Complete!' : 'Loading...'}
      </Text>
    </div>
  );
};



const App: React.FC = () => {
  return (
      <FakeProgressBar  />
  );
};

export default App;
